import React from 'react';
import { CheckCircle2Icon, DatabaseIcon, RefreshCwIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const benefits = [{
  icon: DatabaseIcon,
  title: 'Most comprehensive accounting database',
  description: 'Access the largest database of accounting firms in the US — 250K+ CPAs, tax preparers, bookkeepers, and audit specialists with verified owner contact information across all 50 states.'
}, {
  icon: ShieldCheckIcon,
  title: 'Verified accounting owner contacts',
  description: 'Get direct accounting email lists and phone numbers for managing partners, owners, and decision-makers. Our accounting owner database is verified in real-time for 97% accuracy.'
}, {
  icon: RefreshCwIcon,
  title: 'Weekly accounting database updates',
  description: 'Our accounting business database is refreshed weekly with new firms, updated owner contact information, and the latest business intelligence to keep your accounting email list current.'
}, {
  icon: ZapIcon,
  title: 'Built-in email sequencing',
  description: 'Launch multi-step email campaigns directly to accounting owner contacts without exporting. Send personalized outreach to your accounting email list with our built-in tools.'
}];
export function AccountingValueProps() {
  return <section className="py-24 bg-white" data-id="element-498">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-499">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-500">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-501">
            Why buy <span className="text-blue-600" data-id="element-502">accounting leads</span> from
            Openmart?
          </h2>
          <p className="text-xl text-slate-600" data-id="element-503">
            The most accurate accounting owner database for B2B sales,
            marketing, and business development teams targeting accounting
            firms.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-504">
          {benefits.map(benefit => <div key={benefit.title} className="bg-slate-50 p-8 rounded-2xl border border-slate-200 hover:border-blue-300 hover:shadow-lg transition-all" data-id="element-505">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6 text-blue-600" data-id="element-506">
                <benefit.icon className="w-6 h-6" data-id="element-507" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-508">
                {benefit.title}
              </h3>
              <p className="text-base text-slate-600 leading-relaxed" data-id="element-509">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}